import { NOT_AVAILABLE, SHORT_NOT_AVAILABLE } from '../../constants'

export const replaceShortNotAvailable = (value?: string) =>
  value === NOT_AVAILABLE ? '' : value

export const replaceNotAvailable = (value?: string) =>
  value === SHORT_NOT_AVAILABLE ? '' : value
